import moment from 'moment'
import React, { Component } from 'react';
import PropTypes from 'prop-types'

import Image from 'react-bootstrap/lib/Image';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import EventDetails from '../components/EventDetails'
import Attendees from '../components/Attendees.js';

import { chunks } from '../utils/array.js'
import { fetchEvents, showEventDetails, hideEventDetails } from '../actions/events.js'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import './Events.css';

import Account from './Account';
import { fetchLocations } from '../actions/locations';

let hidden = null;
let visibilityChange = null;
if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support 
	hidden = 'hidden';
	visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
	hidden = 'msHidden';
	visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
	hidden = 'webkitHidden';
	visibilityChange = 'webkitvisibilitychange';
}

class Events extends Component {

	static defaultProps = {}

	static propTypes = {
		dispatch: PropTypes.func.isRequired
	}

	componentDidMount() {
		const { dispatch } = this.props
		let account = this.props.account
		dispatch(hideEventDetails())
		if (account) {
			dispatch(fetchEvents(account._id))
		}
		document.addEventListener(visibilityChange, this.handleVisibilityChange, false)
	}

	componentDidUpdate = (prevProps) => {
		if (this.props.account !== prevProps.account) {
			const { dispatch } = this.props
			dispatch(fetchEvents(this.props.account._id))
		}
	}

	selectEvent(event) {
		const { dispatch } = this.props
		dispatch(showEventDetails(event))
	}

	handleVisibilityChange = () => {
		if (document[hidden]) {
			const { dispatch } = this.props
			let account = this.props.account
			if (account) {
				dispatch(fetchEvents(account._id))
			}
		} else {
			const { dispatch } = this.props
			let account = this.props.account

			if (account) {
				dispatch(fetchEvents(account._id))
			}
		}
	}

	componentWillUnmount() {
		document.removeEventListener(visibilityChange, this.handleVisibilityChange)
	}


	render() {

		let fetchedEvents = this.props.fetchedEvents
		let rawEvents = this.props.events
		let type = this.props.match.params.type
		let events = rawEvents
		let startDate = moment().startOf('day');
		let account = this.props.account

		if (type) {
			if (type === "upcoming") {
				events = rawEvents.filter((event) => {
					return moment.utc(event.eventDate).isSameOrAfter(startDate);
				})
			} else if (type === "past") {
				events = rawEvents.filter((event) => {
					return moment.utc(event.eventDate).isBefore(startDate);
				})
			}
		}
		
		if (fetchedEvents) {
			if (events && events.length > 0) {
				events = events.sort((event1, event2) => {
					let event1Date = moment(event1.eventDate)
					event1Date.hour(0)
					event1Date.minute(0)
					event1Date.second(0)
					let event2Date = moment(event2.eventDate)
					event2Date.hour(0)
					event2Date.minute(0)
					event2Date.second(0)

					if (type === "upcoming") {
						let sort = 0
						if (moment(event1Date).isAfter(event2Date)) {
							sort = 1
						} else if (moment(event1Date).isBefore(event2Date)) {
							sort = -1
						} else {
							if (event1.sessions && event1.sessions.length > 0 && event2.sessions && event2.sessions.length > 0) {
								let sessions1Dates = event1.sessions.map(session => session.startDate)
								var event1MinDate = new Date(Math.min.apply(null, sessions1Dates));

								let sessions2Dates = event2.sessions.map(session => session.startDate)
								var event2MinDate = new Date(Math.min.apply(null, sessions2Dates));

								if (moment(event1MinDate).isAfter(event2MinDate)) {
									sort = 1
								} else if (moment(event1MinDate).isBefore(event2MinDate)) {
									sort = -1
								}
							}
						}
						return sort
					}

					if (type === "past") {
						let sort = 0
						if (moment(event1Date).isAfter(event2Date)) {
							sort = -1
						} else if (moment(event1Date).isBefore(event2Date)) {
							sort = 1
						} else {
							if (event1.sessions && event1.sessions.length > 0 && event2.sessions && event2.sessions.length > 0) {
								let sessions1Dates = event1.sessions.map(session => session.startDate)
								var event1MinDate = new Date(Math.min.apply(null, sessions1Dates));

								let sessions2Dates = event2.sessions.map(session => session.startDate)
								var event2MinDate = new Date(Math.min.apply(null, sessions2Dates));

								if (moment(event1MinDate).isAfter(event2MinDate)) {
									sort = -1
								} else if (moment(event1MinDate).isBefore(event2MinDate)) {
									sort = 1
								}
							}
						}
						return sort
					}
				})

				let organizedEvents = chunks(events, 2)

				return (
					<div>
						<br />
						<Grid>
							{organizedEvents.map((row) => (
								<Row>
									{row.map((event) => {

										let availableSession = event.sessions.find(s => s.attending && s.attending.length < event.capacity)
										let attendingSession = event.sessions.find(s => s.attending.map(a => a._id).indexOf(account._id) > -1)
										let checkedInSession = event.sessions.find(s => s.checkedIn.map(a => a._id).indexOf(account._id) > -1)
										let attendingLabel = undefined

										if (checkedInSession) {
											attendingLabel = "Checked In - " + moment(checkedInSession.startDateTime).format("h:mm a")
											if (checkedInSession.attending && checkedInSession.attending.length > event.capacity) {
												attendingLabel = attendingLabel + " - Event Full"
											}
										} else if (attendingSession) {
											attendingLabel = "Attending - " + moment(attendingSession.startDateTime).format("h:mm a")
											if (attendingSession.attending && attendingSession.attending.length > event.capacity) {
												attendingLabel = attendingLabel + " - Event Full"
											}
										} else if (!availableSession) {
											attendingLabel = "Event Full"
										}

										let badgeClass = attendingLabel ? "attendingBadge" : "hiddenBadge"
										return (
											<Col xs={12} sm={6} style={{ paddingLeft: "0px", paddingRight: "0px", margin: "0px" }}>
												<div class="eventContainer" onClick={this.selectEvent.bind(this, event)}>
													{<Image style={{ minHeight: "250px", width: "100%" }} src={event.listImage} responsive />}
													<div class="content">{event.eventLink.title}</div>
													<div class={badgeClass}>{attendingLabel}</div>
													<div class="rightDivider"></div>
													<div class="leftDivider"></div>
													<div class="bottomDivider"></div>
													<div class="eventDate">{moment(event.eventDate).format("MMM D")}</div>
												</div>
											</Col>
										)
									}
									)}
								</Row>
							)
							)}
						</Grid>

						<EventDetails />
						<Attendees />
					</div>
				)
			} else {
				return (
					<div class="container text-center" style={{ fontSize: "15px", paddingTop: "100px" }}>
						{type === "upcoming" ? "No upcoming events available." : "No past events available."}
					</div>
				)
			}
		} else {
			return (<div></div>)
		}
	}
}

const mapStateToProps = state => {
	return { ...state.eventsReducer, account: state.authReducer.account }
}

export default withRouter(
	connect(mapStateToProps)(Events)
);



// WEBPACK FOOTER //
// ./src/components/Events.js